import { Controller } from "@hotwired/stimulus"

// Drives one catalog-search ranking-rule modal: shows the value picker that matches the selected
// subject (and hides it entirely for "in_stock"), disables the inactive pickers so only the active
// one submits, and keeps the row's summary label in sync with the direction/subject/strength selects.
export default class extends Controller {
  static targets = ["subject", "direction", "strength", "label", "valueGroup"]

  connect() {
    this.sync()
  }

  sync() {
    const subject = this.hasSubjectTarget ? this.subjectTarget.value : null

    this.valueGroupTargets.forEach((group) => {
      const active = group.dataset.subject === subject
      group.classList.toggle("hidden", !active)
      group.querySelectorAll("select, input").forEach((el) => {
        el.disabled = !active
        el.dispatchEvent(new CustomEvent("toggle:disabled", { detail: { disabled: !active } }))
      })
    })

    this.updateLabel()
  }

  updateLabel() {
    if (!this.hasLabelTarget) return
    const text = (select) => {
      if (!select) return ""
      const option = select.options[select.selectedIndex]
      return option ? option.text : ""
    }
    const parts = [
      text(this.hasDirectionTarget ? this.directionTarget : null),
      text(this.hasSubjectTarget ? this.subjectTarget : null),
      text(this.hasStrengthTarget ? this.strengthTarget : null),
    ].filter(Boolean)
    this.labelTarget.textContent = parts.join(" · ")
  }
}
